/* Recohaus — shared AJAX cart helper.
   Single source of truth for /cart/add.js. All PDP hero JS files call
   window.rrAddToCart so we never have to fix the same "Network error after a
   successful add" bug in four places again.

   Key invariant: once the /cart/add.js POST resolves 2xx, the cart was
   updated server-side. Any throw past that point (drawer render, animation
   helper, fly-to-cart) is logged but MUST NOT surface as a fetch failure.
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.rrAddToCart = function (form, options) {
    options = options || {};
    var onSuccess = typeof options.onSuccess === 'function' ? options.onSuccess : function () {};
    var onError = typeof options.onError === 'function' ? options.onError : function () {};
    var openDrawer = options.openDrawer !== false;

    var fd = new FormData(form);
    if (!fd.has('sections')) {
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) {
        return res.json().then(
          function (body) { return { ok: res.ok, status: res.status, body: body }; },
          function () { return { ok: res.ok, status: res.status, body: null }; }
        );
      })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.body && (result.body.description || result.body.message)) || 'Could not add to cart.';
          onError({ type: 'server', status: result.status, message: message });
          return;
        }

        // Cart was updated successfully on the server. Everything below is
        // best-effort UX; any throw must NOT surface as "Network error."
        try {
          onSuccess(result.body || {});
        } catch (e) {
          console.warn('[rr-cart] onSuccess callback threw after successful add:', e);
        }

        if (!openDrawer) return;

        try {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && result.body && result.body.sections) {
            drawer.renderContents(result.body);
          } else if (drawer && typeof drawer.open === 'function') {
            setTimeout(function () {
              try { drawer.open(); }
              catch (e) { console.warn('[rr-cart] drawer.open threw:', e); }
            }, reduceMotion ? 0 : 200);
          } else {
            setTimeout(function () {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }, reduceMotion ? 0 : 400);
          }
        } catch (e) {
          console.warn('[rr-cart] drawer integration threw:', e);
        }
      })
      .catch(function (err) {
        console.error('[rr-cart] fetch failed:', err);
        onError({ type: 'fetch', message: 'Network error. Please try again.' });
      });
  };

  // Fly-to-cart microinteraction: small orange dot animates from the CTA
  // toward the header cart icon, ending with a quick scale bounce on the icon.
  window.rrFlyToCart = function (sourceElement) {
    if (reduceMotion) return;
    if (!sourceElement) return;

    var cartIcon =
      document.getElementById('cart-icon-bubble') ||
      document.querySelector('cart-icon-bubble') ||
      document.querySelector('.rr-header__icon--cart') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('a[href$="/cart"] svg') ||
      document.querySelector('a[href$="/cart"]');
    if (!cartIcon) return;

    var srcRect = sourceElement.getBoundingClientRect();
    var destRect = cartIcon.getBoundingClientRect();
    if (!srcRect.width || !destRect.width) return;

    var dot = document.createElement('div');
    dot.setAttribute('aria-hidden', 'true');
    dot.style.cssText = [
      'position:fixed',
      'left:' + (srcRect.left + srcRect.width / 2 - 20) + 'px',
      'top:' + (srcRect.top + srcRect.height / 2 - 20) + 'px',
      'width:40px',
      'height:40px',
      'border-radius:50%',
      'background:rgb(var(--color-accent))',
      'box-shadow:0 4px 16px rgba(var(--color-accent),0.5)',
      'z-index:9999',
      'pointer-events:none',
      'transition:transform 600ms cubic-bezier(0.5,0,0.5,1),opacity 600ms ease-out',
      'will-change:transform,opacity'
    ].join(';');

    document.body.appendChild(dot);

    requestAnimationFrame(function () {
      var dx = destRect.left + destRect.width / 2 - (srcRect.left + srcRect.width / 2);
      var dy = destRect.top + destRect.height / 2 - (srcRect.top + srcRect.height / 2);
      dot.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.3)';
      dot.style.opacity = '0';

      setTimeout(function () {
        var originalTransform = cartIcon.style.transform || '';
        var originalTransition = cartIcon.style.transition || '';
        cartIcon.style.transition = 'transform 200ms cubic-bezier(0.34,1.56,0.64,1)';
        cartIcon.style.transform = 'scale(1.25)';
        setTimeout(function () {
          cartIcon.style.transform = originalTransform;
          setTimeout(function () {
            cartIcon.style.transition = originalTransition;
          }, 200);
        }, 200);
      }, 500);

      setTimeout(function () {
        if (dot.parentNode) dot.parentNode.removeChild(dot);
      }, 700);
    });
  };
})();
